export default "__VITE_ASSET__CZ7puf6L__"